import { render } from "./EmailProviderError.vue?vue&type=template&id=1fee9bf4&scoped=true"
import script from "./EmailProviderError.vue?vue&type=script&lang=js"
export * from "./EmailProviderError.vue?vue&type=script&lang=js"

import "./EmailProviderError.vue?vue&type=style&index=0&id=1fee9bf4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fee9bf4"]])

export default __exports__